// src/components/Banner/Banner.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Image from "../designLayouts/Image";

// Single banner import
import banner1 from "../../assets/images/banner/banner1.jpeg";

const Banner = () => {
  const [dotActive, setDotActive] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (_, next) => setDotActive(next),
    appendDots: (dots) => (
      <div className="absolute bottom-4 w-full flex justify-center">
        <ul className="flex gap-2">{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        className={`px-3 py-1 cursor-pointer border-r-2 ${
          i === dotActive ? "border-black text-black" : "border-white text-transparent"
        }`}
      >
        0{i + 1}
      </div>
    ),
    responsive: [
      {
        breakpoint: 576,
        settings: {
          dots: true,
          appendDots: (dots) => (
            <div className="absolute bottom-2 w-full flex justify-center">
              <ul className="flex gap-1">{dots}</ul>
            </div>
          ),
          customPaging: (i) => (
            <div
              className={`px-2 py-1 cursor-pointer border-r-2 text-xs ${
                i === dotActive ? "border-black text-black" : "border-white text-transparent"
              }`}
            >
              0{i + 1}
            </div>
          ),
        },
      },
    ],
  };

  return (
    <div className="relative w-full">
      <Slider {...settings}>
        <Link to="/offer">
          <div>
            <Image imgSrc={banner1} alt="BCC Mart Banner 1" />
          </div>
        </Link>
      </Slider>
    </div>
  );
};

export default Banner;
